// extracted by mini-css-extract-plugin
module.exports = {"container":"_1NiQHz2nTx3Z7TbhcPmoll","cancelBtn":"BAg0_eIflIKZwVjxLrsVL","icon":"_1yzrnoQqIjgkRYlvmmttPn","saveBtn":"_2VHuBmpXMigtPXQfSmiYId"};